import ReactionButton from "./ReactionButton";

const ActionButtonSection = ({
  liked,
  likeCount,
  commentsCount,
  isBookmarked,
  toggleLike,
  handleCommentPressed,
  toggleBookmark,
  formatLikes,
  postId,
  reactionsData = null,
  reactionsReady = false,
  availableReactions = [],
  onReactionUpdate,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="d-flex align-items-center gap-3">
        {reactionsReady && postId ? (
          <ReactionButton
            type="post"
            targetId={postId}
            reactionsData={reactionsData}
            availableReactions={availableReactions}
            onReactionUpdate={onReactionUpdate}
            formatLikes={formatLikes}
          />
        ) : (
          <div
            className="d-flex align-items-center gap-2"
            style={{ cursor: "pointer" }}
            onClick={() => {
              toggleLike();
            }}
          >
            <img
              src={liked ? "icons/post-liked.svg" : "icons/post-like.svg"}
              alt={liked ? "liked" : "like"}
              style={{ width: "24px", height: "24px" }}
            />
            <span style={{ color: "#D0D8DF" }} className="counts-text">
              {formatLikes(likeCount)}
            </span>
          </div>
        )}

        {/* Comment button */}
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => {
            handleCommentPressed();
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.9 19.11C16.84 22.17 12.32 22.83 8.61 21.12C8.06 20.89 7.62 20.72 7.19 20.72C6.01 20.72 4.53 21.87 3.76 21.11C2.99 20.34 4.15 18.86 4.15 17.67C4.15 17.24 3.97 16.8 3.75 16.25C2.04 12.55 2.7 8.02 5.76 4.97C9.66 1.07 16 1.07 19.9 4.97C23.81 8.88 23.8 15.21 19.9 19.11Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16.77 12.45H16.78"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.76 12.45H12.77"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M8.75 12.45H8.76"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span style={{ color: "#D0D8DF" }} className="counts-text">
            {formatLikes(commentsCount)}
          </span>
        </div>
      </div>

      {/* Bookmark button */}
      <div
        onClick={() => {
          toggleBookmark();
        }}
        style={{ cursor: "pointer" }}
      >
        {isBookmarked ? (
          <img
            src="/icons/bookmarked.svg"
            alt="saved"
            style={{ width: "24px", height: "24px" }}
          />
        ) : (
          <img
            src="/icons/bookmark-not-saved.svg"
            alt="not-saved"
            style={{ width: "24px", height: "24px" }}
          />
        )}
      </div>
    </div>
  );
};

export default ActionButtonSection;
